<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>称重系统设置</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list">
                    <el-form-item>
                        <el-input placeholder="工厂" clearable v-model="searchData.factory"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="产品" clearable v-model="searchData.product_name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="SN" clearable v-model="searchData.sn"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.result" clearable placeholder="结果">
                            <el-option label="正常" :value="1"></el-option>
                            <el-option label="异常" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="检测日期" class="date_picker form_item ">
                        <DatePicker :date="createTime" disabledDate="true" :clearable="true" @dateSelect="createTimeSelect"></DatePicker>
                    </el-form-item> 
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportSn">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="factory" label="工厂"></el-table-column>
                <el-table-column prop="product_name" label="产品"></el-table-column>
                <el-table-column prop="sn" label="SN"></el-table-column>
                <el-table-column prop="weight" label="重量(kg)"></el-table-column>
                <el-table-column label="结果">
                    <template slot-scope="scope" >
                        <span class="result" v-if="scope.row.result == 1">正常</span>
                        <span class="result result1" v-if="scope.row.result == 2">异常</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="create_time" label="检测日期">
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.create_time)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
    </div>
</template>
<script>
export default({
    name: 'weight-log',
    data() {
        return {
            searchData: {
                page: 1,
                page_size: 10,
                factory: '',
                product_name: '',
                result: '',
                start_create_time: '',
                end_create_time: '',
                sn: ''
            },
            createTime: [],
            listData: [],
            total: 0
        }
    },
    watch: {
        createTime: function(nTime) {
            if(nTime) {
                this.searchData.start_create_time = nTime[0]/1000;
                this.searchData.end_create_time =  nTime[1]/1000;
            }else{
                this.searchData.start_create_time = '';
                this.searchData.end_create_time = '';
            }
            
        }
    },
    created() {
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        createTimeSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        getList() {
            this.api.ptGetWeightLog(this.searchData).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        exportSn() {
            if(!this.searchData.start_create_time || !this.searchData.end_create_time) {
                this.$message.warning('请先选择日期');
            }else{
                const params = {...this.searchData};
                delete params.page;
                delete params.page_size;
                this.api.ptGetWeightLogExport(params);
            }
        }
    }
})
</script>
<style lang="less" scoped>
    .result{
        color: #2A79FF;
        &.result1{
            color: #EB534B;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/weight/log.vue